<template>
    <span class="font-weight-medium caption tabular-nums">
        {{ time | format_date_short }}
    </span>
</template>

<script>
export default {
    name: "RichDataTableTime",
    props: {
        time: {
            type: [String, Number],
            default: null
        }
    }
};
</script>
